import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import CloseButton from '~/components/svg/CloseButton'

const Container = styled.div`
  top: 20px;
  right: 20px;
  position: absolute;
  z-index: 4;
  ${props => props.circle ? `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props.theme.colors.text.menuItem};
  border-radius: 50%;
  padding: 10px;
  ` : null}
`

const FixedCloseButton = ({ onClick, color, circle }) => {
  return (
    <Container circle={circle}>
      <CloseButton
        size="20px"
        color={color}
        onClick={onClick}
      />
    </Container>
  )
}

FixedCloseButton.defaultProps = {
  color: '#FFFFFF',
  // isMobile: false,
  circle: false
}

FixedCloseButton.propTypes = {
  color: PropTypes.string,
  // isMobile: PropTypes.bool,
  circle: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}

export default FixedCloseButton
